// extracted by mini-css-extract-plugin
export default {"rowWidth":"AssignBulkPopup_rowWidth__U2NNS","selectFilter":"AssignBulkPopup_selectFilter__INnEy","caseAssignTable":"AssignBulkPopup_caseAssignTable__17IhH"};